// text输入框限制只能输入数字
export const textInputAllowOnlyNumbers = (e: Event, defaultValue: string = '0'): string => {
  const el = e.target as HTMLInputElement
  let value = el.value

  // 1. 检查是否包含非法字符（除了数字和小数点）
  if (/[^.\d]/.test(value)) {
    return defaultValue
  }

  // 2. 检查小数点数量（最多一个）
  const dotCount = (value.match(/\./g) || []).length
  if (dotCount > 1) {
    return defaultValue
  }

  const setValue = parseFloat(value)
  if (isNaN(setValue)) {
    return defaultValue
  } else {
    return value
  }
}

export const formatToFixedDecimal = (target: HTMLInputElement, decimal: number): number => {
  let value = target.value.trim()

  // 空值处理
  if (value === '' || value === '.') {
    target.value = (0).toFixed(decimal ?? 3)
    return 0
  }

  // 转为数字
  const num = parseFloat(value)

  if (isNaN(num)) {
    target.value = (0).toFixed(decimal ?? 3)
  } else {
    // 四舍五入保留三位小数，并转为字符串
    target.value = num.toFixed(decimal ?? 3)
  }

  const setValue = parseFloat(target.value)
  if (isNaN(setValue)) {
    target.value = (0).toFixed(decimal ?? 3)
    return 0
  }
  return setValue
}

export const formatNumber = (value: number, decimal: number) => {
  return value.toFixed(decimal ?? 3)
}
